import Constants from "expo-constants";

export function getCurrentVersionTimestamp(): number | undefined {
  return Constants?.expoConfig?.extra?.buildRunTimestamp;
}

export function getCurrentVersion(): string | undefined {
  return Constants?.expoConfig?.version;
}
